module.exports = __webpack_public_path__ + "static/media/gallery-lg-6.fed805c5.jpg";